<template>
  <InfoBranch
    v-if="!!item.config && item.config['target-url']"
    :content="item.config['target-url']"
    :style="{
      marginTop: '2px',
    }"
  />
</template>
<script>
import InfoBranch from '../utils/InfoBranch'
export default {
  name: 'shortUrlVisited',
  components: {
    InfoBranch
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>